import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { type ComponentProps } from 'react';

import { Logo } from '../../Logo/Logo';
import { ReactComponent as LogoWithNyeHat } from './LogoWithNyeHat.svg';

export const NyeLogo = observer(function NyeLogo(props: ComponentProps<typeof Logo>) {
	return (
		<Tooltip
			{...{
				title: 'Happy New Year!',
				placement: 'right',
				children: <Logo {...{ children: <LogoWithNyeHat />, ...props }} />,
			}}
		/>
	);
});
